import React from 'react';
import { Box, Button, Stack } from '@mantine/core';
import { IconBuildingStore, IconSettings } from '@tabler/icons-react';
import { Outlet, useNavigate } from 'react-router-dom';
import EmptyState from '@/components/ui/Empty.State';
import ErrorState from '@/components/ui/Error.State';
import ListSkeleton from '@/components/ui/List.Skeleton';
import { CompanyContext } from '@/components/company/company.context';
import { useCompanyState } from '@/hooks/use.company';
import { selectSessionRole } from '@/store/auth/auth.selectors';
import { useAppSelector } from '@/store/store.hooks';

const EDITORS = ['owner', 'admin'];

const CompanyGate: React.FC = () => {
    const navigate = useNavigate();
    const role = useAppSelector(selectSessionRole);
    const state = useCompanyState();

    if (state.company) {
        return (
            <CompanyContext.Provider value={state.company}>
                <Outlet />
            </CompanyContext.Provider>
        );
    }

    if (state.isLoading) {
        return (
            <Stack gap="md" aria-busy="true" aria-label="Carico i dati aziendali">
                <ListSkeleton rows={2} avatar={false} />
                <ListSkeleton rows={5} />
            </Stack>
        );
    }

    if (state.missing) {
        const canEdit = role !== null && EDITORS.includes(role);
        return (
            <Box mt="xl" style={{ display: 'grid', placeItems: 'center' }}>
                <EmptyState
                    icon={IconBuildingStore}
                    title="Prima di tutto, i dati della tua azienda"
                    body={canEdit
                        ? 'Preventivi, fatture e conti fiscali partono da partita IVA, regime e sede. Compilali una volta nelle Impostazioni: da lì valgono per tutta la dashboard.'
                        : 'I dati fiscali dell’azienda non sono ancora stati compilati. Chiedi a un amministratore di farlo dalle Impostazioni.'}
                    action={canEdit ? (
                        <Button leftSection={<IconSettings size={16} />} onClick={() => navigate('/settings/company')}>Compila i dati aziendali</Button>
                    ) : undefined}
                />
            </Box>
        );
    }

    return (
        <ErrorState
            title="Non è stato possibile leggere i dati aziendali"
            body="Servono a calcolare imposte e totali, quindi la pagina aspetta. Riprova fra un attimo."
            onRetry={() => { void state.refetch(); }}
            retrying={state.isFetching}
        />
    );
};

export default CompanyGate;
